import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// services
import * as MarketplaceService from '_services/marketplace-service';

const initialState = {
    userMarketplaceProducts: [],
    status: 'idle',
    error: null,
};

/*
export const getUserMarketplaceProducts = createAsyncThunk('userMarketplaceProducts/getUserMarketplaceProducts', async (retailerId) => {
    return MarketplaceService.getUserMarketplaceProducts(retailerId);
})
*/ 

export const getUserMarketplaceProducts = createAsyncThunk('userMarketplaceProducts/getUserMarketplaceProducts', async (retailerId) => {
    return MarketplaceService.getFirebaseProducts(retailerId);
})

const userMarketplaceProductsSlice = createSlice({
    name: 'userMarketplaceProducts',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [getUserMarketplaceProducts.pending]: (state) => {
            state.status = 'loading';
            state.error = null;
            state.userMarketplaceProducts = [];
        },
        [getUserMarketplaceProducts.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.userMarketplaceProducts = action.payload;
        },
        [getUserMarketplaceProducts.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        }
    }
});

export const { reset } = userMarketplaceProductsSlice.actions;

// selectors
export const selectUserMarketplaceProducts = (state) => state.userMarketplaceProducts.userMarketplaceProducts;
export const selectUserMarketplaceProductsStatus = (state) => state.userMarketplaceProducts.status;
export const selectUserMarketplaceProductsError = (state) => state.userMarketplaceProducts.error;

export default userMarketplaceProductsSlice.reducer;
